import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path d="M10 10.2727C10 9.26857 10.8954 8.45455 12 8.45455C13.1046 8.45455 14 9.26857 14 10.2727V20.1818C14 21.186 13.1046 22 12 22C10.8954 22 10 21.186 10 20.1818V10.2727Z" />
    <path d="M10 3.81818C10 2.81403 10.8954 2 12 2C13.1046 2 14 2.81403 14 3.81818C14 4.82234 13.1046 5.63636 12 5.63636C10.8954 5.63636 10 4.82234 10 3.81818Z" />
  </svg>
);

const InformationIcon = (props) => <Icon component={SVG} {...props} />;

export default InformationIcon;
